import Copy from './Copy.vue'

export default Copy
